/* IntersectionObserver fallback for browsers without animation-timeline support */
if (!CSS.supports('animation-timeline', 'view()')) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('hb-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll(
    '.section-wrapper, .slideshow-section, [class*="custom-liquid"] .section, .resource-list__item, .resource-list__slide'
  ).forEach((el) => observer.observe(el));
}
